import { NotificationContainer } from 'react-notifications'
import 'react-notifications/lib/notifications.css'
import Loader from './app/components/Loader'
import { useAppDispatch, useAppSelector } from './app/redux/hooks'
import { selectGeneral } from './app/redux/slices/general.slice'
import { useEffect, useState } from 'react'
import { resetState, selectAuthenticatedUser, setAuthenticatedUser } from './app/redux/slices/auth.slice'
import { initializeAuthFromStorage, ensureValidToken } from './app/utils/tokenUtils'
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap'
import { BrowserRouter, Link } from 'react-router-dom'
import RootNavigation from './app/navigation/RootNavigation'

function App() {
  const general = useAppSelector(selectGeneral)
  const { name, access_token, role } = useAppSelector(selectAuthenticatedUser)
  const dispatch = useAppDispatch()
  const [finishedInitialize, setFinishedInitialize] = useState(false)

  useEffect(() => {
    const initializeAuth = async () => {
      const userData = initializeAuthFromStorage()
      
      if (userData) {
        dispatch(setAuthenticatedUser(userData))
        
        // Try to ensure token is valid (refresh if needed)
        const isValid = await ensureValidToken()
        if (!isValid) {
          console.log('Token validation failed, user logged out')
        } else {
          console.log('User authenticated successfully:', userData)
        }
      }
      
      setFinishedInitialize(true)
    }

    initializeAuth()
  }, [dispatch])

  const logout = () => {
    localStorage.removeItem('user')
    dispatch(resetState())
  }

  if (!finishedInitialize) {
    return <div className="App"></div>
  }

  return (
    <BrowserRouter>
      <div className="App">
        <NotificationContainer />
        <Loader show={general.showLoader} />
        <Navbar bg="dark" expand="lg" variant="dark">
          <Container>
            <Navbar.Brand as={Link} to="/">SixDegree</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link as={Link} to="/database">Database</Nav.Link>
                {/* TODO: Implement About page functionality */}
                {/* <Nav.Link as={Link} to="/about">About</Nav.Link> */}
              </Nav>
              <Nav>
                {access_token ? (
                  <>
                    <Nav.Item className="text-light d-flex align-items-center me-2">
                      <span>Hi, {name}</span>
                    </Nav.Item>
                    <NavDropdown title="Account" id="basic-nav-dropdown" align="end">
                      <NavDropdown.Item as={Link} to="/profile">Profile</NavDropdown.Item>
                      {role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/admin">Admin Dashboard</NavDropdown.Item>
                      )}
                      <NavDropdown.Divider />
                      <NavDropdown.Item onClick={logout}>Logout</NavDropdown.Item>
                    </NavDropdown>
                  </>
                ) : (
                  <Nav.Link as={Link} to="/login">Login</Nav.Link>
                )}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <div className="container mt-3">
          <RootNavigation />
        </div>
      </div>
    </BrowserRouter>
  )
}

export default App
